import {atom} from "jotai";
import {atomWithReset} from "jotai/utils";

export const accountInfoAtom = atomWithReset({
  username: '',
  password: '',
  confirmPassword:'',
  mediaType:'DIRECT',
  siteName: '',
  siteUrl: '',
  managerName1:'',
  managerPhone1: '',
  managerEmail1: '',
  managerName2:'',
  managerPhone2: '',
  managerEmail2: '',
  serviceTermsId:0,
  isAgreedByServiceTerms:false,
  privacyTermsId:0,
  isAgreedByPrivacyTerms:false,
  operationTermsId:0,
  isAgreedByOperationTerms:false
})
export const nextStepAtom = atom({
  terms: false,
  validation: false
})
export const termsInfoAtom = atom(null)
export const loginParams = {
  id: '',
  password: ''
}
